import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import TimeSelector from "./TimeSelector";
import { getDateAndDay } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

function CalendarView({
  setStatus,
  setTabType,
  doctorSlots,
  setDoctorsFilter,
  setPaymentFilter,
}) {
  const [day, setDay] = useState({ first: "", second: "", third: "" });
  const [dateCounter, setDateCounter] = useState(0);

  return (
    <div style={{ minHeight: "35rem" }} className="d-flex gap-2 text-black">
      <div className="flex-1">
        <details className="flex-1 shadow me-5 rounded">
          <summary style={{ background: "#F9FAFD" }} className=" p-3 rounded">
            {secureLocalStorage.getItem("first_name")}
          </summary>
          <div className="d-flex flex-column gap-3  p-3  rounded-bottom border-top-0">
            <CardDiv
              component={
                <div className="d-flex">
                  <div className="flex-1">Break days:</div>
                  <div className="flex-1">Shifts:</div>
                </div>
              }
            />
            <CardDiv
              title={getDateAndDay(dateCounter).date}
              component={
                <div className="d-flex gap-4">
                  <span className="flex-1 border-end">Total: 0</span>
                  <span className="flex-1 border-end">Booked: 0</span>
                  <span className="flex-1 ">Available: 0</span>
                </div>
              }
            />
            <CardDiv
              title={getDateAndDay(dateCounter - 1).date}
              component={
                <div className="d-flex gap-4">
                  <span className="flex-1 border-end">Total: 0</span>
                  <span className="flex-1 border-end">Booked: 0</span>
                  <span className="flex-1 ">Available: 0</span>
                </div>
              }
            />
            <CardDiv
              title={getDateAndDay(dateCounter + 1).date}
              component={
                <div className="d-flex gap-4">
                  <span className="flex-1 border-end">Total: 0</span>
                  <span className="flex-1 border-end">Booked: 0</span>
                  <span className="flex-1 ">Available: 0</span>
                </div>
              }
            />
          </div>
        </details>
      </div>
      <div className="flex-1">
        <div className="d-flex gap-5">
          <div
            className="flex-1 cursor-pointer"
            onClick={() => {
              setDateCounter(dateCounter - 1);
            }}
          >
            <CardDiv
              title={
                <h5 className="text-center">
                  {getDateAndDay(dateCounter - 1).day}
                </h5>
              }
              component={
                <div className="text-center">
                  {getDateAndDay(dateCounter - 1).date}
                </div>
              }
            />
          </div>
          <div className="flex-1">
            <CardDiv
              title={
                <h5 className="text-center">
                  {getDateAndDay(dateCounter).day}
                </h5>
              }
              component={
                <div className="text-center">
                  {getDateAndDay(dateCounter).date}
                </div>
              }
            />
          </div>
          <div
            className="flex-1 cursor-pointer"
            onClick={() => {
              setDateCounter(dateCounter + 1);
            }}
          >
            <CardDiv
              title={
                <h5 className="text-center">
                  {getDateAndDay(dateCounter + 1).day}
                </h5>
              }
              component={
                <div className="text-center">
                  {getDateAndDay(dateCounter + 1).date}
                </div>
              }
            />
          </div>
        </div>
        <TimeSelector date={getDateAndDay(dateCounter).date} />
      </div>
    </div>
  );
}

export default CalendarView;
